import { FC, useRef } from "react"
import writeXlsxFile from "write-excel-file"
import BaseApi from "../../../api/api"
import { NotificationService } from "../../../features/NotificationService/NotificationService"
import { Button } from "@radix-ui/themes"

export type RecodeYandexItem = {
  name: string
  offer_id: string
  count: number
  weight: number
  sizes: string
}

export const DownloadRecodeYaBtn: FC = () => {
  const onClick = useRef(async () => {
    try {
      const { success, items } = await BaseApi.loadRecodeKatrenYandex()
      if (success) {
        writeXlsxFile(items, {
          schema: RECODE_SCHEMA,
          fileName: "recodeWb.xlsx",
        })
      } else {
        NotificationService.showNotification({
          level: "error",
          message: "Произошла ошибка",
        })
      }
    } catch (e) {}
  })
  return <Button onClick={onClick.current}>Скачать перекодировку</Button>
}

const RECODE_SCHEMA = [
  {
    column: "name",
    value: (item: RecodeYandexItem) => item.name,
  },
  {
    column: "offer_id",
    value: (item: RecodeYandexItem) => item.offer_id,
  },
  {
    column: "count",
    value: (item: RecodeYandexItem) => item.count,
  },
  {
    column: "weight",
    value: (item: RecodeYandexItem) => item.weight,
  },
  {
    column: "sizes",
    value: (item: RecodeYandexItem) => item.sizes,
  },
]
